/* eslint-disable max-lines */
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Week from './Week';

const OuterWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: var(--color-base-1);
  margin-top: 284px;
  overflow: scroll;
  padding-top: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    top: 0;
    margin-top: 215px;
    position: fixed;
    padding: 0 16px;
  }
`;

const InnerWrapper = styled.div`
  width: 1136px;
  margin: auto;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    min-height: 75vh;
    grid-template-columns: repeat(10, 1fr);
    grid-column-gap: ${Spacings.SPACING_2B};
  }
`;

const WeekListing = ({
  weeklyDetails,
  selectedWeek,
  onWeekSelect,
  sessionType,
  selectedSubject,
  weeksRef,
  weekContainerRef,
  hasAccessToBatch,
  batchGoalUID
}) => {
  return (
    <OuterWrapper ref={weekContainerRef}>
      <InnerWrapper>
        {weeklyDetails?.map((week) => (
          <Week
            data={week}
            key={week.weekNumber}
            onWeekSelect={onWeekSelect}
            isExpanded={selectedWeek === week.weekNumber}
            sessionType={sessionType}
            selectedSubject={selectedSubject}
            weeksRef={weeksRef}
            hasAccessToBatch={hasAccessToBatch}
            batchGoalUID={batchGoalUID}
          />
        ))}
      </InnerWrapper>
    </OuterWrapper>
  );
};

export default WeekListing;
